import LocationWorkerType from "@/models/LocationWorkers/LocationWorkerType";

export default class CreateLocationWorkerRequest  {
	locationId: string;
	workerId: string;
	type: LocationWorkerType = LocationWorkerType.Favourite;
}